<div class="outer">
  <div class="bar"></div>
  <div class="bar"></div>
  <div class="bar"></div>
</div>
